<script setup lang="ts">
    import { IChatMessage } from '@/js/services/api/chat/chat';
    import AddAsWidget from './AddAsWidget.vue';
    import ChatMessage from './ChatMessage.vue';
    import ChartWidget from '../widgets/ChartWidget.vue';
    import ParsedMarkdown from '../ParsedMarkdown.vue';
    import { onMounted, ref } from 'vue';
    import { __ } from '@/js/stores/expressions';

    const props = defineProps<{ message: IChatMessage }>();

    const chartData = ref<JSON | null>(null);

    onMounted(() => {
        try {
            chartData.value = JSON.parse(props.message.content as string) ?? {};
        } catch (error) {
            console.error('Failed to parse chart data:', error);
            chartData.value = null;
        }
    });
</script>

<template>
    <ChatMessage :message="message">
        <ParsedMarkdown :markdown="message.message || ''" />

        <template #after>
            <div
                class="mt-2 rounded-lg p-4 pr-10 relative"
                :class="!chartData ? 'bg-orange/15' : 'bg-white shadow-md border-gray-light border'"
            >
                <template v-if="chartData">
                    <AddAsWidget widget-type="StaticGraph" :data="chartData" />
                    <ChartWidget :data="chartData" />
                </template>
                <template v-else>
                    <div class="">
                        {{ __('chart-data-error') }}
                    </div>
                </template>
            </div>
        </template>
    </ChatMessage>
</template>
